import { render, staticRenderFns } from "./asinAttribute.vue?vue&type=template&id=e382c6d2"
import script from "./asinAttribute.vue?vue&type=script&lang=js"
export * from "./asinAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports